"use strict";

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var editor_meta_1 = __importDefault(require("@widget-editor/shared/lib/editor-meta"));

var selectors_1 = require("@widget-editor/shared/lib/modules/configuration/selectors");

var selectors_2 = require("@widget-editor/shared/lib/modules/widget-config/selectors");

var selectors_3 = require("@widget-editor/shared/lib/modules/editor/selectors");

var selectors_4 = require("@widget-editor/shared/lib/modules/filters/selectors");

var selectors_5 = require("@widget-editor/shared/lib/modules/end-user-filters/selectors");

var filters_1 = require("../filters");

var getSerializedWidgetConfig = function getSerializedWidgetConfig(store, adapter) {
  var advanced = selectors_3.selectAdvanced(store);
  var serializedWidgetConfig = {};

  if (selectors_1.selectVisualizationType(store) !== 'map') {
    var widgetConfig = selectors_2.selectSerializedWidgetConfig(store);
    Object.keys(widgetConfig).forEach(function (key) {
      serializedWidgetConfig[key] = widgetConfig[key];
    });

    if (serializedWidgetConfig.$schema) {
      delete serializedWidgetConfig.$schema;
    }

    if (!advanced) {
      serializedWidgetConfig.paramsConfig = {
        visualizationType: selectors_1.selectVisualizationType(store),
        limit: selectors_1.selectLimit(store),
        value: selectors_1.selectValue(store),
        category: selectors_1.selectCategory(store),
        color: selectors_1.selectColor(store),
        size: selectors_1.selectSize(store),
        orderBy: selectors_1.selectOrderBy(store),
        aggregateFunction: selectors_1.selectAggregateFunction(store),
        chartType: selectors_1.selectChartType(store),
        filters: filters_1.getSerializedFilters(selectors_4.selectFiltersList(store)),
        endUserFilters: selectors_5.selectEndUserFilters(store),
        areaIntersection: selectors_1.selectAreaIntersection(store),
        band: selectors_1.selectBand(store),
        donutRadius: selectors_1.selectDonutRadius(store),
        sliceCount: selectors_1.selectSliceCount(store)
      };
    }
  } else {
    serializedWidgetConfig.type = 'map';
    serializedWidgetConfig.layer_id = selectors_1.selectLayer(store);
    serializedWidgetConfig.zoom = selectors_3.selectZoom(store);
    serializedWidgetConfig.lat = selectors_3.selectLat(store);
    serializedWidgetConfig.lng = selectors_3.selectLng(store);
    serializedWidgetConfig.bounds = selectors_3.selectBounds(store);
    serializedWidgetConfig.bbox = selectors_3.selectBbox(store);

    if (selectors_3.selectBasemap(store)) {
      serializedWidgetConfig.basemapLayers = selectors_3.selectBasemap(store);
    }

    serializedWidgetConfig.paramsConfig = {
      visualizationType: selectors_1.selectVisualizationType(store),
      layer: selectors_1.selectLayer(store)
    };
  }

  serializedWidgetConfig.we_meta = editor_meta_1["default"](adapter.getName(), advanced);
  return serializedWidgetConfig;
};

var getOutputPayload = function getOutputPayload(store, adapter) {
  return {
    name: selectors_1.selectTitle(store),
    description: selectors_1.selectDescription(store),
    widgetConfig: getSerializedWidgetConfig(store, adapter),
    metadata: {
      caption: selectors_1.selectCaption(store)
    }
  };
};

exports["default"] = getOutputPayload;